import { apiV2 } from "@/lib/apiV2/apiV2";
import { useQuery } from "@tanstack/react-query";

export const useUsersV2 = () => {
  const {
    data: usersData,
    error,
    isLoading: loadingUsers,
  } = useQuery({
    queryKey: ["usersv2"],
    queryFn: apiV2.users.getAll,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const users = usersData?.data;
  const usersError = error?.message;

  return { users, usersError, loadingUsers };
};

export const useUserMeV2 = () => {
  const {
    data: userData,
    error,
    isLoading: userLoading,
  } = useQuery({
    queryKey: ["userv2"],
    queryFn: apiV2.users.getMe,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const user = userData?.data;
  const userError = error?.message;

  return { user, userError, userLoading };
};
